<template>
  <h1 class="loading-ellipsis">
    <span class="one">.</span>
    <span class="two">.</span>
    <span class="three">.</span>
  </h1>
</template>

<script>
  export default {}
</script>



// WEBPACK FOOTER //
// HeadingLoading.vue?c71b211a